﻿import { ConfiguratorDI, Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { IManufactureObject, PartRev } from "@models/configurators/partrev";
import { UiObject } from "@models/configurators/ui-object";

@Kbo(CToken.PartMaterial)
export class PartMaterial extends PartRev implements IManufactureObject {

    public $properties: UiObject[];

    public pullAsAsm: boolean;
    public mtlPartNum: string;

    constructor(kom: KbObjectManager, data?: any) {
        super(kom, data);
    }

    public getIdentifyingProperty() {
        return "mtlPartNum";
    }

    public static getMetadataProperties() {
        return ["getDetails"];
    }
}